import { render } from "./tableFooter.vue?vue&type=template&id=a0eef39a"
import script from "./tableFooter.vue?vue&type=script&lang=js"
export * from "./tableFooter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__